import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import PropTypes from 'prop-types';
import LinkButton from 'components/Components/UI/LinkButton';
import Modal from 'components/Components/UI/Modal';
import GetQuoteForm from 'components/Components/Forms/GetQuoteForm/Loadable';
import { Link } from 'react-router-dom';
import HeaderFormQuote from "components/Components/Includes/HeaderFormQuote";
import { CONSTANTS } from 'services/constants';
import GetQuoteHubspotForm from 'components/Components/Forms/GetQuoteHubspotForm';
const { HOTEL_IDS } = CONSTANTS.DATA.BUSINESS_LOGIC.HUBSPOT_FORM;

class RectangularListElem extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            showModalQuote: false,
            showModalReadMore: false,
        };
        this.handleOpenModalQuote = this.handleOpenModalQuote.bind(this);
        this.handleCloseModalQuote = this.handleCloseModalQuote.bind(this);
        this.handleOpenModalReadMore = this.handleOpenModalReadMore.bind(this);
        this.handleCloseModalReadMore = this.handleCloseModalReadMore.bind(this);
    }

    handleOpenModalQuote()
    {
        this.setState({ showModalQuote: true });
    }

    handleCloseModalQuote()
    {
        this.setState({ showModalQuote: false });
    }

    handleOpenModalReadMore()
    {
        this.setState({ showModalReadMore: true });
    }

    handleCloseModalReadMore()
    {
        this.setState({ showModalReadMore: false });
    }

    render()
    {
        const {
            image, title, description, travelWin, bookingWin, blackoutDates, termsConditions, goingTo, id, type, titleType, headerPhoneNumber, headerLogo
        } = this.props;

        let [
            renderTravelWin, renderBookingWin, renderWin, renderBlackoutDates, renderModal, renderTerms, paddingLeft,
        ] = '';

        const isHotelAvailableToShowHubspotForm = type === 'hotel' && HOTEL_IDS.includes(id);

        if (travelWin)
        {
            renderTravelWin = (
                <div className="tw-w-full lg:tw-w-1/2 tw-mt-8">
                    <p className="tw-uppercase font-sp tw-mb-4">Travel Window</p>
                    <p>{travelWin}</p>
                </div>
            );
            paddingLeft = 'lg:tw-pl-4';
        }

        if (bookingWin)
        {
            renderBookingWin = (
                <div className={`tw-w-full lg:tw-w-1/2 tw-mt-8 ${paddingLeft}`}>
                    <p className="tw-uppercase font-sp tw-mb-4">Booking Window</p>
                    <p>{bookingWin}</p>
                </div>
            );
        }

        if (travelWin || bookingWin)
        {
            renderWin = (
                <>
                    <hr className="tw-border-gray-500 tw-mt-8 tw-hidden md:tw-block" />
                    <div className="md:tw-flex md:tw-flex-wrap tw-hidden">
                        {renderTravelWin}
                        {renderBookingWin}
                    </div>
                </>
            );

            renderModal = (
                <div className="tw-flex tw-flex-wrap tw-mt-8 md:tw-mt-16 lg:tw-w-1/2">
                    {renderTravelWin}
                    {renderBookingWin}
                </div>
            );
        }

        if (blackoutDates)
        {
            renderBlackoutDates = (
                <div className="tw-w-full tw-mt-8">
                    <p className="tw-uppercase font-sp tw-mb-4">Blackout Dates</p>
                    <p>{blackoutDates}</p>
                </div>
            );
        }

        if (termsConditions)
        {
            renderTerms = (
                <>
                    <hr className="tw-border-gray-500 tw-my-8" />
                    <p className="tw-uppercase font-sp tw-mb-4">Terms and Conditions</p>
                    <p>{termsConditions}</p>
                </>
            );
        }

        return (
            <>
                {/* Content */}
                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap tw-mb-12 md:tw-mb-24">
                        <div className="tw-w-full tw-h-64 md:tw-h-auto md:tw-w-1/2 md:tw-pr-4 xl:tw-pr-5">
                            <div className="tw-bg-center tw-bg-cover tw-h-full tw-w-full tw-cursor-pointer" onClick={this.handleOpenModalReadMore} style={{ backgroundImage: `url(${image})` }} />
                        </div>
                        <div className="tw-w-full md:tw-w-1/2 md:tw-pl-4 xl:tw-pl-5 tw-text-left tw-mt-8 md:tw-mt-0">
                            <div className="tw-flex tw-content-between tw-flex-wrap tw-h-full">
                                <div className="tw-w-full">
                                    <h4 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-6">{title}</h4>
                                    <p>{`${description.replace(/(<([^>]+)>)/ig, ' ').slice(0, 170)} ...`}</p>
                                    {renderWin}
                                </div>
                                <div className="tw-w-full tw-mt-8">
                                    <div className="tw-flex tw-flex-wrap">
                                        <div className="tw-w-full lg:tw-w-1/2 lg:tw-pr-3">
                                            <LinkButton
                                                text="Quote"
                                                onClick={this.handleOpenModalQuote}
                                                link="#"
                                                className="tw-w-full"
                                                color="orange"
                                            />
                                        </div>
                                        <div className="tw-w-full lg:tw-w-1/2 lg:tw-pl-3 tw-mt-2 lg:tw-mt-0">
                                            <LinkButton
                                                text="Read more"
                                                onClick={this.handleOpenModalReadMore}
                                                link="#"
                                                className="tw-w-full"
                                                color="gray"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>

                {/* Modal Quote */}
                { this.state.showModalQuote && (
                    <Modal
                        isOpen={this.state.showModalQuote}
                        modalTitle=""
                    >
                        <Link className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400" to="#" onClick={this.handleCloseModalQuote}>
                            <span className="tw-uppercase font-sp">Close</span>
                            <span className="material-icons tw-align-middle tw-ml-2">close</span>
                        </Link>
                        <HeaderFormQuote
                            logo={headerLogo}
                            url={null}
                            onClose={this.handleCloseModalQuote}
                            phoneNumber={headerPhoneNumber}
                            altLogo={title + ' logo'}
                        />
                        {isHotelAvailableToShowHubspotForm ? (
                            <GetQuoteHubspotForm />
                        ) : (
                            <GetQuoteForm
                                image={image}
                                title={title}
                                titleType={titleType}
                                goingTo={goingTo}
                                description={description}
                                bookingWin={bookingWin}
                                travelWin={travelWin}
                                id={id}
                                type={type}
                                onCloseModal={this.handleCloseModalQuote}
                            />
                        )}
                    </Modal>
                )}

                {/* Modal Read More */}
                { this.state.showModalReadMore && (
                    <Modal
                        isOpen
                        modalTitle={title}
                    >
                        <Link className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400" to="#" onClick={this.handleCloseModalReadMore}>
                            <span className="tw-uppercase font-sp">Close</span>
                            <span className="material-icons tw-align-middle tw-ml-2">close</span>
                        </Link>
                        <div className="tw-text-left">
                            {renderModal}
                            <hr className="tw-border-gray-500 tw-my-8" />
                            <p className="tw-uppercase font-sp tw-mb-4">Description</p>
                            <p>{description}</p>
                            <p className="tw-mt-10"><strong>Call us today: <a className="hover:tw-text-orange-400" href="tel:18447858575">1 (844) 785-8575</a></strong></p>
                            {renderBlackoutDates}
                            {renderTerms}
                        </div>
                        <LinkButton
                            text="Close"
                            onClick={this.handleCloseModalReadMore}
                            link="#"
                            className="tw-w-auto tw-mt-10"
                            color="gray"
                        />
                    </Modal>
                )}
            </>
        );
    }
}

RectangularListElem.defaultProps = {
    titleType: null,
};

RectangularListElem.propTypes = {
    image: PropTypes.node.isRequired,
    goingTo: PropTypes.string,
    title: PropTypes.node.isRequired,
    titleType: PropTypes.string,
    description: PropTypes.node.isRequired,
    id: PropTypes.number,
    travelWin: PropTypes.string,
    bookingWin: PropTypes.string,
    blackoutDates: PropTypes.string,
    termsConditions: PropTypes.string,
    type: PropTypes.string,
    headerPhoneNumber: PropTypes.string,
    headerLogo: PropTypes.string,
};

export default RectangularListElem;
